import { ParseProduction } from './parse-production';

export class ParseProductionImplementationPvSys  extends  ParseProduction {

  findColumnsProduction(csvData: string[][]): number {
    for (const row of csvData) {
      if(row[0] === 'date') {
        return row.findIndex((value) => value === 'E_Grid' || value === 'EOutInv');
      }
    }
    return 0;
  }

  findRowProduction(csvData: string[][]): number {
    return csvData.findIndex((row) => row[0].startsWith('01/01/'));
  }

  get dateFormat() {
    return 'DD/MM/YY HH:mm';
  }
}
